class StorageService {
  public setObject = (key: string, object: any) => {
    localStorage.setItem(key, JSON.stringify(object));
  }

  public getObject = (key: string) => {
    const object = localStorage.getItem(key);
    return object && JSON.parse(object);
  }

  public clear = () => {
    localStorage.clear();
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new StorageService();
